<template>
  <div class="form-cps-register container">
    <header v-if="!loadingData">
      <h2 class="form-title">{{ getTitle }}</h2>
      <div class="alert alert-info alert-required-fields" role="alert">
        <label>{{ getInformationMessage }}</label>
        <br />
        Tous les champs de ce formulaire avec
        <span class="text-danger">*</span> sont
        <span class="text-danger">obligatoires</span>.
      </div>
    </header>

    <main>
      <cps-individual
        :formData="this.formData"
        :registrationData="this.registrationData"
        v-if="!loadingData && !loadingError && formData"
      ></cps-individual>
      <admin-loader
        :loading="loadingData"
        v-else-if="!loadingError"
      ></admin-loader>
      <div v-else class="alert alert-danger">
        {{ $texts.formLoadingError }}
      </div>
    </main>
    <footer-panel-vuetify
      :silentRefreshUrl="$appSettings.SilentRefreshUrl"
    ></footer-panel-vuetify>
  </div>
</template>

<script>
import Vue from "vue";
import AdminLoader from "../../../Commons/AdminLoader.vue";
import CpsIndividual from "../../components/cps-cpx/CpsIndivual.vue";
import { InscriptionFlowService } from "../../services/InscriptionFlowService";
import { RegistrationService } from "../../services/RegistrationService";
import { RegistrationSubMode } from "../../models/enums/RegistrationSubMode";
import FooterPanelVuetify from "@/Commons/components/FooterPanelVuetify.vue";
import StringHelper from "../../../Commons/StringHelper.ts";

export default Vue.extend({
  name: "form-cps-register",

  components: {
    AdminLoader,
    CpsIndividual,
    FooterPanelVuetify,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
    },
    nationalId: {
      type: String,
    },
  },

  data() {
    return {
      formData: null,
      idFormType: null,
      registrationData: null,
      loadingData: false,
      loadingError: null,
    };
  },

  computed: {
    getTitle() {
      switch (this.registrationData.registrationSubMode) {
        case RegistrationSubMode.Update:
          return this.$texts.titleFormUpdateRegisterCard;
        default:
          return this.$texts.titleFormRegisterCard;
      }
    },
    getInformationMessage() {
      switch (this.registrationData.registrationSubMode) {
        case RegistrationSubMode.Update:
          return this.$texts.registerUpdateInformationMessage;
        case RegistrationSubMode.CreationWithoutAssociation:
          return this.$texts.registerLinkInformationMessage;
        default:
          return this.$texts.registerInformationMessage;
      }
    },
  },

  methods: {
    async getFormData(name, idFormType) {
      InscriptionFlowService.getFormData(name, idFormType)
        .then((formData) => {
          this.formData = formData;
          this.loadingData = false;
        })
        .catch((error) => {
          this.loadingError = error;
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    getRegistrationData(name) {
      this.loadingData = true;
      return RegistrationService.initialization(name)
        .then((registrationData) => {
          this.registrationData = registrationData;
          this.idFormType = registrationData.formType;

          if (!StringHelper.isNullOrWhitespace(this.email)) {
            this.registrationData.user.email = this.email;
          }

          if (!StringHelper.isNullOrWhitespace(this.nationalId)) {
            this.registrationData.user.nationalId = this.nationalId;
          }
        })
        .catch((error) => {
          this.loadingError = error;
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },

  watch: {
    name: {
      immediate: true,
      handler(val) {
        this.getRegistrationData(val, this.idFormType).then(() => {
          this.getFormData(val, this.idFormType);
        });
      },
    },
  },
});
</script>

<style scoped>
header {
  text-align: left;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

main {
  text-align: left;
}
</style>
